/* eslint-disable max-len */
import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import useForm from '../../../../customHooks/useForm';
import ProfileTitle from '../ProfileTitle';
import ProfileLabelAndTitle from '../../../../components/ProfileLabelAndTitle';
import useToast from '../../../../customHooks/useToast';
import CopyIcon from '../../../../svgs/CopyIcon';
import { toTitleCase } from '../../../../utils/helpers';
import { formatCash } from '../../../../utils/tableHelpers';

interface IPersonalInfo{
  payload:any;
  buttonState?: boolean
  index?: number
}
export const PersonalInfo = ({
  payload, index,
}:IPersonalInfo) => {
  const Toast = useToast();
  const ProfileHeaderName = payload?.userRtDetail
    ?.enrolled_as_student ? 'Student Details' : 'Personal Details';
  const [isPersonalDetailHidden, setIsPersonalDetailHidden] = useState(false);

  const {
    formValues,
  } = useForm(
    {
      enrollment_type: payload?.userRtDetail?.enrollment_type || '********',
      enrollment_type_other: payload?.userRtDetail?.enrollment_type_other || '********',
      firstName: payload?.firstName || '********',
      lastName: payload?.lastName || '********',
      email: payload?.email || '********',
      phone: payload?.phone || '********',
      gender: payload?.gender || '********',
      dob: payload?.dob || '********',
      nationality: payload?.userRtDetail?.nationality || '********',
      studentId: `ID: ${payload?.studentId || '********'}`,
      permanentResidency: payload?.userRtDetail?.enrollment_type !== 'permanent_resident' ? 'No' : 'Yes',
      canadaStatus: payload?.userRtDetail?.enrollment_type === 'others' ? `Others  (${toTitleCase(payload?.userRtDetail?.enrollment_type_other?.split('_')?.join(' ') || '')
      })` : toTitleCase(payload?.userRtDetail?.enrollment_type?.split('_')?.join(' ') || '') || '********',
      employmentStatus: toTitleCase(payload?.userRtDetail?.employment_status || ''),
      monthlyIncome: formatCash(payload?.userRtDetail?.monthly_income, 'CAD' || ''),
    },
  );

  return (
    <div>
      <ProfileTitle
        name={ProfileHeaderName}
        index={index}
        onClick={() => setIsPersonalDetailHidden(!isPersonalDetailHidden)}
      />
      {isPersonalDetailHidden && (
        <div className="profile-detail-cover">
          <ProfileLabelAndTitle
            content={formValues}
            attribute={[
              'firstName',
              'lastName',
              'studentId',
              'email',
              'phone',
              'gender',
              'dob',
              'nationality',
              'canadaStatus',
              ...(payload?.userRtDetail?.employment_status ? ['employmentStatus'] : []),
              ...(payload?.userRtDetail?.monthly_income ? ['monthlyIncome'] : []),
            ]}
            label={{
              firstName: 'First Name',
              lastName: 'Last Name',
              studentId: (
                <>
                  <span className="student-id">Student ID</span>
                  {' '}
                  <CopyToClipboard
                    onCopy={() => Toast.success('Copied to clipboard')}
                    text={formValues.studentId}
                  >
                    <span className="icon_cover" style={{ cursor: 'pointer' }}>
                      <CopyIcon />
                    </span>
                  </CopyToClipboard>
                </>
              ),
              email: 'Email Address',
              phone: 'Phone Number',
              gender: 'Gender',
              dob: 'Birthdate',
              nationality: 'Nationality',
              canadaStatus: 'Canada Status',
              employmentStatus: 'Employment Status',
              monthlyIncome: 'Monthly Income',

            }}
          />
        </div>
      )}

    </div>
  );
};
